import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Tabs, Typography } from 'antd';
import ScenarioTable from '../../components/ScenarioTable';
import Localization from '../../utils/localization';
import { accountActions, periodsActions } from '../../redux/actions';

const { TabPane } = Tabs;
const { Title } = Typography;

const NUM_DEFAULT_TABS = 4;

const EntityBusinessCase = ({ accountStructure, periods, expandedPeriods, assembledBusinessCase }) => {
    const dispatch = useDispatch();

/* Might be redundant since accountStructure and periods are already fetched in the parent component
    useEffect(() => {
        dispatch(accountActions.getAccountStructure());
        dispatch(periodsActions.getPeriods());
    }, [dispatch]);
*/
    const createCustomTabs = (accountStructure) => {
        if (periods !== null && periods.length > 0) {
            let count = 0;

           const customTabs = (accountStructure?.custom || [])
                .flat()
                .map((tab) =>  {
                const key = (count + NUM_DEFAULT_TABS + 1).toString();
                count++;

                return (
                    <TabPane tab={tab.name} key={key}>
                        <Title
                            level={2}
                            style={{
                                textAlign: 'left',
                                marginTop: '10px',
                                marginBottom: '30px',
                                textShadow: '0.5px 0.5px 0.5px  #aab7b8',
                            }}
                        >
                            {tab.name}
                        </Title>
                        <ScenarioTable
                            accounts={tab.custom_tab_accounts}
                            structure={accountStructure}
                            scenario={assembledBusinessCase?.scenario}
                            periods={periods}
                            expandedPeriods={expandedPeriods}
                        />
                    </TabPane>
                );
            });
            return customTabs;
        }
    };

    const renderContent = () => {
        return (
            <div>
                <Tabs onChange={() => {}} type="card" destroyInactiveTabPane>
                    <TabPane tab={Localization.common.profitAndLoss} key="1">
                        <ScenarioTable
                            accounts={accountStructure?.profitloss}
                            structure={accountStructure}
                            scenario={assembledBusinessCase?.scenario}
                            periods={periods}
                            expandedPeriods={expandedPeriods}
                        />
                    </TabPane>
                    <TabPane tab={Localization.common.balanceSheet} key="2">
                        <Title level={4} style={{ textAlign: 'left' }}>
                            {Localization.common.assets}
                        </Title>
                        <ScenarioTable
                            accounts={accountStructure?.balancesheet?.assets}
                            structure={accountStructure}
                            scenario={assembledBusinessCase?.scenario}
                            periods={periods}
                            expandedPeriods={expandedPeriods}
                        />
                        <Title level={4} style={{ textAlign: 'left', marginTop: '40px' }}>
                            {Localization.common.liabilities}
                        </Title>
                        <ScenarioTable
                            accounts={accountStructure?.balancesheet?.liabilities}
                            structure={accountStructure}
                            scenario={assembledBusinessCase?.scenario}
                            periods={periods}
                            expandedPeriods={expandedPeriods}
                        />
                        <Title level={4} style={{ textAlign: 'left', marginTop: '40px' }}>
                            {Localization.common.equities}
                        </Title>
                        <ScenarioTable
                            accounts={accountStructure?.balancesheet?.equities}
                            structure={accountStructure}
                            scenario={assembledBusinessCase?.scenario}
                            periods={periods}
                            expandedPeriods={expandedPeriods}
                        />
                    </TabPane>
                    <TabPane tab={Localization.common.cashFlow} key="3">
                        <ScenarioTable
                            accounts={accountStructure?.cashflow}
                            structure={accountStructure}
                            scenario={assembledBusinessCase?.scenario}
                            periods={periods}
                            expandedPeriods={expandedPeriods}
                        />
                    </TabPane>
                    <TabPane tab={Localization.common.drivers} key="4">
                        <ScenarioTable
                            accounts={accountStructure?.drivers}
                            structure={accountStructure}
                            scenario={assembledBusinessCase?.scenario}
                            periods={periods}
                            expandedPeriods={expandedPeriods}
                        />
                    </TabPane>

                    {createCustomTabs(accountStructure)}
                </Tabs>
            </div>
        );
    };
    return renderContent();
};
export default EntityBusinessCase;
